export function tabPropsAreEqual(
  prevProps: { index: number; selected: number },
  nextProps: { index: number; selected: number }
): boolean {
  const isNextPropEqual =
    nextProps.selected === nextProps.index && prevProps.selected !== prevProps.index;
  const isPrevPropEqual =
    nextProps.selected !== nextProps.index && prevProps.selected === prevProps.index;

  return !(isNextPropEqual || isPrevPropEqual);
}
